<div class="tab-pane fade show active py-5"
  id="nav-combo"
  role="tabpanel" >
  <router-outlet></router-outlet>
</div>
<!-- content-carrito seleccion-producto -->
